import type { LocationGenerics } from "@/router/locationGenerics";
import { getAccountContext } from "@/router";

import { FindOneSyncDocument } from "@/apollo/types";
import { ReverseEltSyncBreadcrumb } from "@/components/elements/breadcrumbs/ReverseEltSyncBreadcrumb";
import LoadingError from "@/components/elements/routing/LoadingError";
import { ApolloClient } from "@apollo/client";
import { Navigate, Route } from "@tanstack/react-location";

export const exportsRoute = (
  client: ApolloClient<object>,
): Route<LocationGenerics> => {
  return {
    path: "reverse-etl",
    meta: {
      breadcrumb: () => "Reverse ETL",
    },
    children: [
      {
        path: "new",
        element: () =>
          import("./new/CreateSyncPage").then((m) => <m.default />),
        meta: {
          breadcrumb: () => "New",
        },
      },
      {
        path: "usage",
        element: <Navigate to="../../settings/usage" hash="reverse-etl" />,
      },
      {
        path: ":syncId",
        meta: {
          breadcrumb: ({ syncId }) => (
            <ReverseEltSyncBreadcrumb syncId={syncId} />
          ),
        },
        children: [
          {
            path: "configuration",
            element: () =>
              import("./EditReverseEltSync").then((m) => <m.default />),
            meta: {
              breadcrumb: () => "Configuration",
            },
          },
          {
            element: () =>
              import("./ReverseEltSync").then((m) => <m.default />),
            errorElement: <LoadingError />,
            loader: async (match) =>
              (
                await client.query({
                  query: FindOneSyncDocument,
                  variables: { syncId: match.params.syncId },
                  context: await getAccountContext(match.params.slug, client),
                })
              ).data,
          },
        ],
      },
      {
        element: () => import("./ReverseEltSyncs").then((m) => <m.default />),
      },
    ],
  };
};
